import { render } from "./App.vue?vue&type=template&id=7e541584"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7e541584&lang=css"

import exportComponent from "C:\\Users\\anton\\OneDrive\\Escritorios\\09-07-2023\\mailsender\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__